import { Claim, ClaimsState } from './types';
import { ReduxAction, setAsyncData } from '../core';

import { ClaimsAction } from './actions';

const initialState: ClaimsState = {
  claims: { isFetching: false },
};

export function claimsReducer(state: ClaimsState = initialState, action: ReduxAction<any>): ClaimsState {
  switch (action.type) {
    case ClaimsAction.SET_IS_FETCHING:
      return {
        ...state,
        claims: setAsyncData(state.claims, (v) => (v.isFetching = action.data as boolean)),
      };

    case ClaimsAction.ONE_UPDATED:
      // check if the claims page needs to be updated
      if (state.claims.data && state.claims.data.length) {
        return {
          ...state,
          claims: setAsyncData(state.claims, (v) => (v.data = state.claims.data!.map((claim) => (claim.id === action.data.id ? (action.data as Claim) : claim)))),
        };
      } else {
        return state;
      }
    case ClaimsAction.SET_CLAIMS:
      return {
        ...state,
        claims: setAsyncData(state.claims, (v) => (v.data = action.data as Claim[])),
      };
    default:
      return state;
  }
}
